import React from 'react';
import { map } from 'lodash';
import AbsoluteValue from '../../../common/AbsoluteValue';
import { percentageValue } from '../../../../helpers/NumberFormatter';

export const sourcesSettings = {
    settingsForTable,
    settingsForRow
};


function settingsForTable(mode){
    
    
    let columns = [
      {
              id: 'icon',
              headerClassName: 'table-header-item icon-header icon',
              className: 'icon', 
              Header: '',
              // width: 70,
              accessor: 'source',
              Cell: props => <div className="source-icon"></div>
          },
                                
       {
           id: 'source',
           className: 'imprint-name',
           headerClassName: 'imprint-name',
           Header: 'source',
           accessor: 'source',
           // width: 190
       },
       /*
       {
           id: 'total_streams',
           headerClassName: 'table-header-item streams-header',
           className: 'streams',
           Header: 'Streams',
           Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'total_streams'
       },
       */
       {
           id: 'listeners',
           headerClassName: 'table-header-item streams-header',
           className: 'streams',
           Header: 'Listeners',
           Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'listeners'
       },       
       {
           id: 'share',
           headerClassName: 'table-header-item share',
           className: 'share',
           Header: 'Share',
           // width: 70,
           accessor: 'share',
           Cell: props => <span className="share-val">{props.value}%</span>,
       },
    ];
    return columns.map(column=>{
        //column.show = modes[mode].includes(column.id);
        return column;
    });
}

function settingsForRow(state, rowInfo, column) {
    if(rowInfo===undefined)
        return {};

    return {
        className: `tr-source tr-source-${rowInfo.row.source.toLowerCase().replace(' ', '-')}`
    }
}